module.exports = __webpack_public_path__ + "img/Menu-12.1c8f67bf.png";